import { render, staticRenderFns } from "./address-card.vue?vue&type=template&id=480893da&scoped=true"
import script from "./address-card.vue?vue&type=script&lang=ts"
export * from "./address-card.vue?vue&type=script&lang=ts"
import style0 from "./address-card.vue?vue&type=style&index=0&id=480893da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480893da",
  null
  
)

export default component.exports